const pageViewMiddleware = () => next => action => {
  next(action)

  if (action.type !== '@@router/LOCATION_CHANGE') return;

  try { window.pageView() }
  catch(e) { console.error(e); }
}

export default pageViewMiddleware
